import { darkTheme } from './dark';
import { lightTheme } from './light';

export default {
  light: lightTheme,
  dark: darkTheme
};
